<section style="padding-bottom: 100px;">
    <div class="container">
        <div class="row row-fit-lg fade-bottom" style="position: relative;
        animation-duration: 1000ms;
        transition-timing-function: ease;
        transition-delay: 0ms;">
            <div class="grid-list" style="transform: translateY(-90px);">
                <div class="grid-box">
                    <div class="grid-item">
                        <div class="cnt-box cnt-box-top-icon boxed">
                            <i class="fas fa-desktop text-secondary"></i>
                            <div class="caption">
                                <h2 class="text-primary">Smart software</h2>
                                <p>
                                    Software that is designed to be easy to use and navigate.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item">
                        <div class="cnt-box cnt-box-top-icon boxed">
                            <i class="fas fa-chart-bar text-secondary"></i>
                            <div class="caption">
                                <h2 class="text-primary">Trusted security</h2>
                                <p>
                                    Maintaining security using best-practices and technologies.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item">
                        <div class="cnt-box cnt-box-top-icon boxed">
                            <i class="fas fa-medal text-secondary"></i>
                            <div class="caption">
                                <h2 class="text-primary">On-shore partner</h2>
                                <p>
                                    An on-shore software development partner just for you.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="grid-item">
                        <div class="cnt-box cnt-box-top-icon boxed">
                            <i class="fas fa-user-tie text-secondary"></i>
                            <div class="caption">
                                <h2 class="text-primary">Great experience</h2>
                                <p>
                                    Communicate directly with the programmers on the project!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-section-values></app-section-values>
</section>